import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { Input } from 'components/fields/index'
import { form } from 'helpers/decorators/index'
import { apiDashboard } from 'helpers/decorators/api/index'
import validate from './change-email.validation'
import { Button } from '../../../../components/misc'
import { connect } from 'react-redux'


@apiDashboard.apiPersons()
@form({
  form: 'changeEmailForm',
  disableHook: true,
  validate
})
@connect(({ api }) => ({
  isLoading: api.dashboard.persons.profile.loading
}))
class ChangeEmail extends Component {
  static propTypes = {
    onChangeEmail: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    profile: PropTypes.object,
    isAssessor: PropTypes.bool,
    isLoading: PropTypes.bool
  }

  render() {
    const { handleSubmit, isAssessor, profile, isLoading } = this.props

    return (
      <form
        onSubmit={handleSubmit(fields =>
          this.props.onChangeEmail(get(profile, 'data.id'), fields, {
            resetForm: this.props.reset,
            isAssessor
          })
        )}
      >
        <div className="row">
          <div className="col-xs-12">
            <Input
              name="newEmail"
              label="New email"
              intlKey="label.new_email"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Input
              name="newEmailAgain"
              label="New email again"
              intlKey="label.new_email_again"
            />
          </div>
        </div>

        <div className="row">

          <div className="col-xs-12">
            <div style={{float: 'right'}}>
            <Button
              intlKey='button.change_email'
              compact
              type="submit"
              isLoading={isLoading}
            >
              Change email
            </Button>
          </div>
          </div>
        </div>

      </form>
    )
  }
}

export default ChangeEmail
